import React, { useState, useEffect, useRef } from 'react';

import { Dialog, Card } from '@mui/material';
import { images, icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useIsMobile } from '../../helpers/customHooks';
import SegmentedControl from '../SegmentedControl/SegmentedControl';
import NewButton from '../Buttons/NewButton';


const PaymentsModal = ({ show, data, type, onClose, onSave, deleteAccount }) => {
    const MOBILE = useIsMobile();
    const { t } = useTranslation();

    // const [show, setShow] = useState(props.show)
    const [errorText, setErrorText] = useState("")

    const [companyName, setCompanyName] = useState("")
    const [orgNr, setOrgNr] = useState("")
    const [vatNr, setVatNr] = useState("")
    const [email, setEmail] = useState("")

    // useEffect(() => {
    //     setShow(props.show)

    // },[props.show])


    useEffect(() => {
        if(type){
            setCompanyName(data?.company_name)
            setOrgNr(data?.organization_number)
            setVatNr(data?.vat_number)
            setEmail(data?.invoice_email)
        }
    }, [type])

    
    const handleClose = () => {
        onClose()
      //  setShow(false)
    }

    const handleChange = (type, e) => {
        switch(type){
            case "company_name":
                setCompanyName(e.target.value)
            break;
            case "org_nr":
                setOrgNr(e.target.value)
            break;
            case "vat_nr":
                setVatNr(e.target.value)
            break;
            case "email":
                setEmail(e.target.value)
            break;
            default: return
        }
        setErrorText("")
    }


    const handleSave = (type) => {
        let data = {}
        switch(type){
            case "company_name":
                data = { company_name: companyName }
                break;
            case "org_nr":
                data = { organization_number: orgNr }
                break;
            case "vat_nr":
                data = { vat_number: vatNr }
                break;
            case "email":
                data = { invoice_email: email }
                break;
            default: data = {}
        }
        onSave(data)
    }
    const companyNameContent = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        {/* <img src={icons.user_settings} alt=""/> */}
                        <h3 className="">{t("subscription.change_company_name")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue py-3">{t("subscription.change_company_name_sub")}</p>
                <form>
                    <div className="form-group d-flex align-items-center">
                        <input
                            type="text"
                            className="form-control rounded24 p-3 bg-light-grey grey-blue"
                            id="name"
                            defaultValue={companyName}
                            onChange={(e) => {
                                handleChange("company_name", e);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                e.preventDefault();// Prevent the default Enter key behavior
                                handleSave(type)
                                }
                            }}
                        />
                        <div className="invalid-feedback ms-1 bottom">
                            {errorText === "" ? "" : errorText}
                        </div>
                    </div>
                </form>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => handleSave(type)} className="bg-gradient p-3 rounded24 w-100 white-white ms-2 body bold">{t("settings.save")}</NewButton>
                </div>
            </div>
        )
    }

    const orgNrContent = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        {/* <img src={icons.user_settings} alt=""/> */}
                        <h3 className="">{t("subscription.change_org_nr")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue py-3">{t("subscription.change_org_nr_sub")}</p>
                <form>
                    <div className="form-group d-flex align-items-center">
                        <input
                            type="text"
                            className="form-control rounded24 p-3 bg-light-grey grey-blue"
                            id="name"
                            defaultValue={orgNr}
                            onChange={(e) => {
                                handleChange("org_nr", e);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                e.preventDefault();// Prevent the default Enter key behavior
                                handleSave(type)
                                }
                            }}
                        />
                        <div className="invalid-feedback ms-1 bottom">
                            {errorText === "" ? "" : errorText}
                        </div>
                    </div>
                </form>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => handleSave(type)} className="bg-gradient p-3 rounded24 w-100 white-white ms-2 body bold">{t("settings.save")}</NewButton>
                </div>
            </div>
        )
    }

    const vatNrContent = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        {/* <img src={icons.user_settings} alt=""/> */}
                        <h3 className="">{t("subscription.change_vat_nr")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue py-3">{t("subscription.change_vat_nr_sub")}</p>
                <form>
                    <div className="form-group d-flex align-items-center">
                        <input
                            type="text"
                            className="form-control rounded24 p-3 bg-light-grey grey-blue"
                            id="name"
                            defaultValue={vatNr}
                            onChange={(e) => {
                                handleChange("vat_nr", e);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                e.preventDefault();// Prevent the default Enter key behavior
                                handleSave(type)
                                }
                            }}
                        />
                        <div className="invalid-feedback ms-1 bottom">
                            {errorText === "" ? "" : errorText}
                        </div>
                    </div>
                </form>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => handleSave(type)} className="bg-gradient p-3 rounded24 w-100 white-white ms-2 body bold">{t("settings.save")}</NewButton>
                </div>
            </div>
        )
    }

    const emailContent = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                        <div className='d-flex align-items-center'>
                        {/* <img src={icons.user_settings} alt=""/> */}
                        <h3 className="">{t("subscription.change_recipient")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue py-3">{t("subscription.change_recipient_sub")}</p>
                <form>
                    <div className="form-group d-flex align-items-center">
                        <input
                            type="text"
                            className="form-control rounded24 p-3 bg-light-grey grey-blue body"
                            id="confirmemail"	
                            defaultValue={email}
                            onChange={(e) => {
                                handleChange("email", e);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                e.preventDefault();// Prevent the default Enter key behavior
                                handleSave(type)
                                }
                            }}
                        />
                        <div className="invalid-feedback ms-1 bottom">
                            {errorText === "" ? "" : errorText}
                        </div>
                    </div>
                </form>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => handleSave(type)} className="bg-gradient p-3 rounded24 w-100 white-white body bold ms-2">{t("settings.save")}</NewButton>
                </div>
            </div>
        )
    }

    const typeRender = () => {
        switch(type){
            case "company_name": return companyNameContent()
            case "org_nr": return orgNrContent()
            case "vat_nr": return vatNrContent()
            case "email": return emailContent()
            default: return null
        }
    }
    
    return(
        <>
        <Dialog fullWidth={MOBILE ? true : false} open={show} onClose={handleClose}>
            <Card className="settings-dialog d-flex flex-column">
                <div className="w-100 h-100 grey-blue">
                    {typeRender()}
                </div>
            </Card>
        </Dialog>
        </>
    )
}

export default PaymentsModal;